import { AxiosUpdateTuple, usePutAxiosHook } from '../../AxiosPutHook';

export const useUpdateClientAddresses = (clientId: string): AxiosUpdateTuple => {
  const URL = '/api/clients/' + clientId + '/addresses';

  const [callBack, { data, loading, called, error }] = usePutAxiosHook(URL);

  return [callBack, { data, loading, called, error }];
};
